import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../i18n/LangContext";
import { EASE } from "../lib/util";

export const Preloader = ({ done }) => {
  const { t } = useLang();
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-noor-ink"
        >
          <motion.img
            src="/brand/mark-dark.png"
            alt=""
            initial={{ opacity: 0, y: 14, filter: "blur(8px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            transition={{ duration: 1.2, ease: EASE }}
            className="h-24 w-auto drop-shadow-[0_0_40px_rgba(216,187,134,0.35)]"
          />
          <motion.img
            src="/brand/wordmark-dark.png"
            alt="NOORIN"
            initial={{ opacity: 0, letterSpacing: "0.4em" }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 1.2, ease: EASE }}
            className="mt-6 h-7 w-auto"
          />
          <div className="mt-10 h-px w-48 overflow-hidden bg-noor-pearl/10">
            <motion.div initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 2.4, ease: EASE }} className="h-full origin-left bg-noor-champagne rtl:origin-right" />
          </div>
          <p className="mt-5 text-xs text-noor-mist">{t.preloader}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
